import { makeAutoObservable } from "mobx";

class LayoutStore {
    
    constructor() {
        makeAutoObservable(this)
    }

}


export { LayoutStore };